var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af975c;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a_pied",
    "data-name": "a pied"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.51,26v1.88a.83.83,0,1,1-1.66,0v-2H32.43l-.66,1.82a.82.82,0,0,1-1.06.5.83.83,0,0,1-.49-1.07l.48-1.34a4.81,4.81,0,0,1-2-.83l-1.16,1.5a.83.83,0,0,1-1.16.15.84.84,0,0,1-.15-1.18l1.29-1.67a4.69,4.69,0,0,1-.64-1.31H24.79a.84.84,0,0,1,0-1.68h1.82V18.9H24.79a.84.84,0,0,1,0-1.67h1.82V15.35H24.79a.84.84,0,0,1,0-1.68h1.82V11.8H21.53a.35.35,0,0,1,.35.34v3.24a.35.35,0,0,1-.35.35H12.7l-.22,0V36.36H44V34.71A8.78,8.78,0,0,0,36.51,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.7,11.8h-.22v0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.48,
    y: 36.36,
    width: 31.52,
    height: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.48,29.37v7H19.4a7,7,0,0,0-6.92-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,34.71a8.79,8.79,0,0,0-.92-3.94,5.65,5.65,0,0,0-4.69,5.59H44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.48 38.52 12.48 41.69 14.93 41.69 14.93 40.36 16.9 40.36 16.9 41.69 19.32 41.69 19.32 40.36 21.29 40.36 21.29 41.69 23.34 41.69 23.34 39.67 27.6 39.67 27.6 41.69 30.69 41.69 30.69 40.36 32.66 40.36 32.66 41.69 35.08 41.69 35.08 40.36 37.05 40.36 37.05 41.69 39.59 41.69 39.59 40.36 41.55 40.36 41.55 41.69 44 41.69 44 38.52 12.48 38.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.68,24.68a.84.84,0,0,0-.83.84v2.35a.83.83,0,1,0,1.66,0V25.52A.84.84,0,0,0,35.68,24.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.07,24.42a.83.83,0,0,0-1.06.5l-.79,2.22a.83.83,0,0,0,.49,1.07.82.82,0,0,0,1.06-.5l.8-2.22A.85.85,0,0,0,32.07,24.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.79,15.35h2.33a.84.84,0,0,0,0-1.68H24.79a.84.84,0,0,0,0,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.79,18.9h2.33a.84.84,0,0,0,0-1.67H24.79a.84.84,0,0,0,0,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.94,21.62a.83.83,0,0,0-.82-.84H24.79a.84.84,0,0,0,0,1.68h2.33A.83.83,0,0,0,27.94,21.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.67,23.58l-1.44,1.86a.84.84,0,0,0,.15,1.18.83.83,0,0,0,1.16-.15L29,24.61a.84.84,0,0,0-.14-1.17A.82.82,0,0,0,27.67,23.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.53,15.73H12.7a2,2,0,1,1,0-3.93h8.83a.35.35,0,0,1,.35.34v3.24a.35.35,0,0,1-.35.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPied);
export default __webpack_public_path__ + "static/media/icon_pied.f178b8c8acbdee3d8bcafe8abff8c114.svg";
export { ForwardRef as ReactComponent };